<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="close_box">
					<div class="icon">
						<van-icon name="cross" color="rgb(128, 128, 128)" size="24" @click="closeDialog" />
					</div>
				</div>
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					Add More Products to My Selection
				</div>
				<div class="top_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						Products ({{ total }})
					</div>
					<div class="right">
						<input v-model="searchVal" placeholder="Search by Name, or Keyword" @keyup.enter="searchClick" />
						<van-icon name="search" class="icon" size="28" color="#006BB3" @click="searchClick" />
					</div>
				</div>
				<div class="table_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<el-table
						:data="tableData"
						stripe
						style="width: 100%"
						empty-text="No matching records found"
						v-loading="tableLoading"
					>
						<el-table-column sortable prop="product_name" label="Name" width="420" show-overflow-tooltip>
							<template slot-scope="scope">
								<div style="color: #006BB3; cursor: pointer;" @click="goInfo(scope.row)">{{ scope.row.product_name || '' }}</div>
							</template>
						</el-table-column>
						<el-table-column sortable prop="cate_name" label="TYPE" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								{{ scope.row.cate_name || '' }}
							</template>
						</el-table-column>
						<el-table-column sortable prop="" label="FORMAT" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<div v-if="scope.row.format_name.length > 0">
									<span v-for="(value, index) in scope.row.format_name" :key="index">
										{{ index == scope.row.format_name.length - 1 ? value.title : value.title + ', ' }}
									</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column sortable prop="catalog" label="CATALOG" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								{{ scope.row.catalog || '' }}
							</template>
						</el-table-column>
						<el-table-column  fixed="right" label="" width="60" align="center">
							<template slot-scope="scope">
								<!-- <el-popconfirm
									v-if="scope.row.status == 1"
									class="popconfirm"
									confirm-button-text='Confirm'
									cancel-button-text='Cancel'
									title="Are you sure you want to add it to the list?"
									@confirm="addWatch(scope.row)"
								> -->
									<van-icon v-if="scope.row.status == 1" name="add-o" size="24" style="top: 2px;cursor: pointer;" color="#808080" slot="reference" @click="addWatch(scope.row)" />
								<!-- </el-popconfirm> -->
								<van-icon v-if="scope.row.status == 2" name="passed" size="24" style="top: 2px;" color="#00AB82" />
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="bot_box">
					<div class="left">
						Showing {{ (Number(current_page - 1) * pageNum) + 1 }} to {{ last_page != page ? current_page * pageNum : total }} of {{ total }} entries
					</div>
					<div class="right">
						<div class="page_box">
							<el-pagination
								:small="false"
								background
								layout="prev, pager, next"
								:total="total"
								:page-size="pageNum"
								@current-change="pageChange"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { getProductList } from '@/api/public.js';
export default {
	components:{
		//
	},
	data() {
		return {
			isLoading: true,  //界面loading
			tableData: [],
			current_page: 0,
			last_page: 0,
			pageNum: 10,
			page: 1,
			total: 0,
			searchVal: '',
			tableLoading: false,
			idsStr: [],
			ids: [],
		}
	},
	created(){
		let that = this;
		//获取购物车数据
		if(JSON.parse(localStorage.getItem('idsStr'))) {
			that.idsStr = JSON.parse(localStorage.getItem('idsStr')).split(',');
		}
		if(JSON.parse(localStorage.getItem('ids'))) {
			that.ids = JSON.parse(localStorage.getItem('ids')).split(',');
		}
		//获取产品列表
		that.getProduct();
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//点击表格添加按钮
		addWatch(value) {
			let that = this;
			//缓存至购物车
			that.idsStr.push(value.id + '_1');
			that.ids.push(value.id);
			value.status = 2;
			localStorage.setItem('idsStr', JSON.stringify(that.idsStr.join(',')));
			localStorage.setItem('ids', JSON.stringify(that.ids.join(',')));
			that.$toast('Added successfully');
		},
		//获取产品列表
		getProduct() {
			let that = this;
			that.tableLoading = true;
			getProductList({
				keyword: that.searchVal,
				cate_id: '',
				diseases_id: '',
				diseases_ids: '',
				apps_id:'',
				format: '',
				source: '',
				page: that.page,
				page_size: that.pageNum,
				ids: that.ids.length > 0 ? that.ids.join(',') : ''
			}).then(res => {
				that.tableData = res.data.data;
				that.total = res.data.total;
				that.current_page = res.data.current_page;
				that.last_page = res.data.last_page;
				that.tableLoading = false;
				// console.log(JSON.parse(JSON.stringify(that.tableData[0])));
			});
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.pageNum = 10;
			that.page = 1;
			//获取产品列表
			that.getProduct();
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getProduct();
		},
		//分页条数选择
		pageChange2(val) {
			let that = this;
			that.pageNum = val;
			that.getProduct();
		},
		//跳转详情
		goInfo(value) {
			let that = this;
			if(value.custom) {
				let routeData = that.$router.resolve({name: "ProductInfo", params: { productId: value.custom } });
				window.open(routeData.href, '_blank');
			}else {
				that.$toast('Product parameter exception, failed to obtain details.');
			}
		},
		//关闭弹框
		closeDialog() {
			this.$emit('closeDialog');
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	//banner
	.block_1{
		position: relative;
		padding: 0 80px 60px 80px;
		.close_box{
			display: flex;
			justify-content: end;
			position: absolute;
			left: 60px;
			padding: 0 80px 60px 80px;
			width: 100%;
			.icon{
				position: fixed;
				margin-left: -30px;
				z-index: 1;
				cursor: pointer;
			}
		}
		.bot_box{
			display: flex;
			align-items: center;
			margin-top: 10px;
			padding: 16px 5px 16px 20px;
			background-color: #F6F6F6;
			.right{
				width: auto;
			}
			.left{
				flex: 1;
				color: #808080;
				font-size: 16px;
			}
		}
		.top_box{
			display: flex;
			align-items: center;
			padding: 20px 0;
			.right{
				.icon{
					top: 8px;
					margin-left: 10px;
					cursor: pointer;
				}
				input{
					width: 320px;
					height: 40px;
					line-height: 40px;
					padding: 0 20px;
					font-size: 18px;
					border: 1px solid #808080;
					border-radius: 6px;
					text-align: center;
					color: #006BB3;
				}
			}
			.left{
				flex: 1;
				font-size: 24px;
				font-weight: bold;
			}
		}
		.title{
			text-align: center;
			font-size: 40px;
			color: #E37542;
		}
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pager li:hover{
	color: #E37542 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #E37542 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
>>> .table_box .el-table__header tr th{
	background-color: #003B63;
}
>>> .table_box .el-table__header tr th .cell{
	color: #ffffff;
}
>>> .table_box .el-table .el-table__cell{
	padding: 8px 0;
}
>>> .table_box .el-table__header tr th .sort-caret.ascending{
	border-bottom-color: #ffffff;
}
>>> .table_box .el-table__header tr th .sort-caret.descending{
	border-top-color: #ffffff;
}
>>> .table_box .el-table .descending .sort-caret.descending{
	border-top-color: #E37542;
}
>>> .table_box .el-table .ascending .sort-caret.ascending{
	border-bottom-color: #E37542;
}
</style>